<airport-selector
  [selected]="selected"
  (selectedChange)="update($event)"
></airport-selector>
